module.exports = __webpack_public_path__ + "media/cut-video.f53ff0b8.mp4";